export const openMenuAction=(dispatch,menuContent)=>dispatch({type:'OPEN_MENU',payload:menuContent})
export const closeMenuAction=(dispatch)=>dispatch({type:'CLOSE_MENU'})